import { useCallback, useRef, useState } from 'react';

/** Блокирует повторный submit, пока первый запрос ещё в полёте. */
export function useSubmitGuard() {
  const [submitting, setSubmitting] = useState(false);
  const lock = useRef(false);

  const runSubmit = useCallback(async (action: () => void | Promise<void>) => {
    if (lock.current) return;
    lock.current = true;
    setSubmitting(true);
    try {
      await action();
    } finally {
      lock.current = false;
      setSubmitting(false);
    }
  }, []);

  return { submitting, runSubmit };
}
